.content {
  flex-wrap: wrap;
}
.title > h2,
.content > * {
  width: 600px;
}
